import React from "react";
import PlatformDonut from "./PlatformDonut";
import IssuesPanel from "./IssuesPanel";
import VehicleCard from "./VehicleCard";
import { hasRideshareEarnings } from "./helpers";

const PlatformAndVehicleSection = ({ data }) => {
  const showDonut = hasRideshareEarnings(data.platform_breakdown);

  return (
    <section className="grid grid-cols-1 lg:grid-cols-3 gap-6">
      <div className="lg:col-span-2 bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
        {showDonut ? (
          <>
            <div className="px-6 py-4 border-b border-gray-200 bg-gray-50 flex justify-between items-center">
              <h3 className="text-[12px] uppercase tracking-widest text-gray-500 font-semibold">
                Platform Earnings Breakdown
              </h3>
            </div>
            <PlatformDonut breakdown={data.platform_breakdown} />
          </>
        ) : (
          <IssuesPanel issues={data.issues || []} compact />
        )}
      </div>
      <VehicleCard vehicle={data.vehicle} />
    </section>
  );
};

export default PlatformAndVehicleSection;
